// extracted by mini-css-extract-plugin
export var projectSlider = "ProjectSlider-module--projectSlider--2kbtv";
export var projectItem = "ProjectSlider-module--projectItem--jMcnX";